"use client";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setAfUserId } from "./slice/AppsFlyerSlice";

const AppsFlyerProvider = ({ afuserId, children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (afuserId) {
      dispatch(setAfUserId(afuserId));
    }
  }, [afuserId]);

  return <>{children}</>;
};

export default AppsFlyerProvider;
